import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { BrokerClientApi, DrawApi } from '@apply/api';
import { DrawType } from '@apply/constants';
import { EsignModal } from '../../../esign';
import { useState } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ManualAgreementStringBody, AgreementStringHeader } from '../jsxConstants';

interface ISubmitButtonProps {
    draw: DrawApi.IDraw;
    currentApproval?: DrawApi.IDrawBudgetApproval;
    isEquityMet: boolean;
    applicationInsights: ApplicationInsights;
    borrowerName: string;
    latestDrawBorrowerRequestTotal: number;
    onDrawBorrowerSubmitted: (id: number) => void;
    showFeedback: (value: boolean) => void;
}

export const SubmitButton = ({
    draw,
    currentApproval,
    isEquityMet,
    applicationInsights,
    borrowerName,
    latestDrawBorrowerRequestTotal,
    onDrawBorrowerSubmitted,
    showFeedback,
}: ISubmitButtonProps): JSX.Element => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);
    const brokerClientApi = new BrokerClientApi.BrokerClientApi(applicationInsights);

    const [isEsignOpen, set_isEsignOpen] = useState<boolean>(false);
    const [ipAddress, set_ipAddress] = useState<string>();

    const onSubmitClick = () => {
        brokerClientApi.getIpAddress().then((response) => {
            if (response.statusCode !== 200) return;

            set_ipAddress(response.result);
            set_isEsignOpen(true);
        });
    };

    const onConfirmAgreement = async (font) => {
        await drawApi.drawBorrowerSignature({
            drawId: draw.id,
            fontId: font.id,
            ipAddress: ipAddress,
        });

        onDrawBorrowerSubmitted(draw.id);

        set_isEsignOpen(false);

        if (draw.drawType === 2) {
            showFeedback(true);
        }
    };

    const onRejectAgreement = () => {
        set_isEsignOpen(false);
    };

    if ((draw.borrowerSubmitted && !draw.needsBorrowerSignature) || draw.drawType !== DrawType.Manual || draw.isFinalized)
        return <></>;

    if (!currentApproval) return <DisabledButton titleText='The budget is currently waiting for approval.' />;

    if (!isEquityMet) return <DisabledButton titleText='The equity requirement has not been met.' />;

    if (latestDrawBorrowerRequestTotal === 0) return <DisabledButton titleText='Please enter your budget request.' />;

    return (
        <>
            <button
                onClick={onSubmitClick}
                title='Submit Draw for review.'
                className='button primary'
                style={{ zIndex: 1000 }}
            >
                Submit
            </button>
            <EsignModal
                agreementHtml={manualAgreementString}
                isOpen={isEsignOpen}
                signatureText={borrowerName}
                cancelCallback={onRejectAgreement}
                confirmCallback={(font) => onConfirmAgreement(font)}
                ipAddress={ipAddress}
                rejectLabel='I DO NOT ACCEPT THIS AGREEMENT'
                acceptLabel='I ACCEPT THIS AGREEMENT'
            />
        </>
    );
};

const DisabledButton = ({ titleText }: { titleText: string }) => {
    return (
        <button
            disabled={true}
            title={titleText}
            className='button primary'
            style={{ zIndex: 2001 }}
        >
            Submit
        </button>
    );
};

const manualAgreementString = ReactDOMServer.renderToStaticMarkup(
    <div style={{ paddingLeft: 20, fontSize: 20 }}>
        <p style={{ fontSize: 24, fontWeight: 600 }}>
            <AgreementStringHeader />
        </p>
        <ManualAgreementStringBody />
    </div>
);
